<template>
  <v-card tile min-height="700">
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>积分充值
    </v-card-title>
    <v-card-text style="padding-left:100px;">

      <!-- 预设积分项 -->
      <v-row>
        <v-col cols="auto" v-for="p in pointList" :key="p.id">
          <v-card @click="srId=p.id" :color="p.id==srId ?'primary':''" :dark="p.id==srId" width="200">
            <v-card-text class="text-center">
              <span class="text-h4">{{p.value}}</span>
              <span class="pl-2">积分</span>
            </v-card-text>
            <v-card-actions>
              <v-row justify="center">
                <v-col cols="auto">
                  <div>{{p.amount}} 元</div>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- 发票 -->
      <v-row v-if="switch_invoice">
        <v-col cols="auto">
          <v-switch v-model="invoiceFlag" inset label="是否需要发票"></v-switch>
        </v-col>
        <v-col cols="2" align-self="center">
          <router-link class="primary--text text-button text-decoration-none" :to="`/profile/invoice?odrSrId=${srId}`">发票管理</router-link>
        </v-col>
        <v-col cols="12" v-if="invoiceFlag">
          <p v-if="defaultInvoice == null">
            暂无数据
          </p>
          <div v-else>
            <invoice-detail :form-data="defaultInvoice" />
            <v-btn color="primary" text @click="winVisible=true">选择新的发票信息</v-btn>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="auto">
          <p>请选择支付方式</p>
          <v-radio-group v-model="payType" row>
            <v-radio v-for="pt in payTypes" :key="pt.code" :label="pt.name" :value="pt.code"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12"></v-col>
        <v-col cols="auto" v-if="payType!=0">
          <v-btn x-large width="140" color="primary" @click="onSubmitOrder">确认购买</v-btn>
        </v-col>
      </v-row>

      <!-- 选择发票dialog -->
      <v-dialog v-model="winVisible" max-width="580">
        <invoice-list :editable="false" @choose="onChoose" style="min-height:520px;" />
      </v-dialog>

      <!-- 微信支付二维码dialog -->
      <v-dialog v-model="payingFlag" max-width="450">
        <v-card min-height="400">
          <v-card-title>请使用微信扫码支付</v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="auto">
                <div id="payQrCode"></div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-card-text>
  </v-card>
</template>
<script>
/*eslint no-undef: */
import InvoiceDetail from '../../invoice/InvoiceDetail.vue'
import InvoiceList from '../../invoice/InvoiceList.vue'
import $ from '@/assets/jquery/jquery-vendor.js'
import { getDefaultInvoice, getInvoiceById, createUserWxNativeOrder, createUserAlipayOrder, getPointOrderDetail } from '@/plugins/api'

export default {
  data () {
    return {
      pointList: [
        { id: 1, value: 1000, amount: 10 },
        { id: 2, value: 3000, amount: 30 },
        { id: 3, value: 5000, amount: 50 },
        { id: 4, value: 10000, amount: 100 },
        { id: 5, value: 15000, amount: 150 },
        { id: 6, value: 20000, amount: 200 },
        { id: 7, value: 10, amount: 0.01 },
      ],
      srId: 4,
      invoiceFlag: false,
      winVisible: false,
      defaultInvoice: null,
      btnPayDisabled: false,
      payType: 1, // 1:微信,2:支付宝
      // payTypes: [{ code: 1, name: '微信支付' }, { code: 2, name: '支付宝支付' }],
      payTypes: [{ code: 1, name: '微信支付' }],
      payingFlag: false,
      alipayCode: null,
      odrIvcId: null,

      switch_invoice: false // 暂时关闭订单页面申请发票
    }
  },
  watch: {
    invoiceFlag (v) {
      if (v && !this.odrIvcId && !this.defaultInvoice) this.initDefaultInvoice()
    }
  },
  created () {
    let odrSrId = this.$route.query && this.$route.query.odrSrId
    let odrIvcId = this.$route.query && this.$route.query.odrIvcId
    this.odrIvcId = odrIvcId
    if (odrSrId && odrIvcId) {
      this.srId = odrSrId
      this.invoiceFlag = true
      getInvoiceById(odrIvcId).then(res => this.defaultInvoice = res.data)
    }
  },
  components: { InvoiceDetail, InvoiceList },
  methods: {
    initDefaultInvoice () {
      getDefaultInvoice().then(res => this.defaultInvoice = res.data)
    },
    onChoose (e) {
      this.defaultInvoice = e
      this.winVisible = false
    },
    onSubmitOrder () {
      let sr = this.pointList.find(r => r.id == this.srId)
      let param = { amount: sr.amount * 100, pointAmount: sr.value, note: `生信云平台充值${sr.value}积分` }
      // let param = { amount: sr.amount * 100, pointAmount: sr.value, note: `生信云平台充值${sr.value}积分`, invoiceFlag: this.invoiceFlag }
      // if (this.invoiceFlag) {
      //   param.invoiceId = this.defaultInvoice.id
      //   param.invoiceData = JSON.stringify(this.defaultInvoice)
      // }
      if (this.payType == 1) this.onSubmitWxNativeOrder(param)
      else this.onSubmitAlipayOrder(param)
    },
    onSubmitWxNativeOrder (param) { // 微信native扫码支付: 后台返回二维码,扫码支付后,进入后台回调,后台回调更新订单状态,前端循环加载订单状态
      createUserWxNativeOrder(param).then(res => {
        this.payingFlag = true
        let d = res.data
        this.$nextTick(() => {
          this.createPayQrCode(d.codeUrl)
          this.doLoadOrderFinalStatus(d._orderId)
        })
      })
    },
    onSubmitAlipayOrder (param) { // alipay: 后台返回form表单的html,将html嵌入网页body后,会自动跳转到ali支付页面,支付后进入后端设置的returnUrl,并执行后端的notifyUrl
      createUserAlipayOrder(param).then(res => {
        this.payingFlag = true
        let d = res.data
        $('body').html(d.codeUrl)
      })
    },
    createPayQrCode (content) { // 生成微信扫码支付的二维码
      $('#payQrCode').empty()
      new QRCode(document.getElementById('payQrCode'), content) 
    },
    async doLoadOrderFinalStatus (orderId) { // 循环刷新订单状态
      let times = 0 // 最多刷10次
      let timer = setInterval(async () => {
        await getPointOrderDetail(orderId).then(res => {
          let status = res.data.status
          times++
          if (status) {
            clearInterval(timer)
            timer = undefined
            this.$router.push('/profile/point/order/success')
          } else {
            if (times >= 10) { // 跳转到未知错误页面,可能支付成功了,但是回调没执行到
              clearInterval(timer)
              timer = undefined
              // TODO 目前先一直刷,一直等待后端回调执行成功
            }
          }
        })
      }, 2000)
    }
  }
}
</script>